const ROLES = {
  "Super Admin": 1,
  "Content Admin": 2,
};

module.exports = ROLES;
